import React from 'react'
import FieldColumn from '../field-column'
import { Field } from 'formik'
import MultiSelectField from '../../form/fields/multi-select'
import { buildListAsInputOptions } from '../../../utils/forms'
import { useWorkPeriodTagsQuery } from '../../../queries/work-period-tags'
import { Element } from 'react-bulma-components'

interface WorkPeriodTagsFilterFieldProps {
  disabledQueries?: boolean
  queriesStaleTime?: number
  employerIds?: string[]
  tooltip?: string
  disabled?: boolean
}

/**
 * Component for filtering work period tags in a multi-select field
 * Uses work period tags data from the API
 */
const WorkPeriodTagsFilterField: React.FC<WorkPeriodTagsFilterFieldProps> = ({
  disabledQueries,
  queriesStaleTime,
  employerIds,
  disabled,
  tooltip,
}) => {
  const tagsQuery = useWorkPeriodTagsQuery(
    { employer: employerIds },
    {
      enabled: !disabledQueries,
      staleTime: queriesStaleTime,
    },
  )

  return (
    <FieldColumn>
      <Element data-tooltip={tooltip}>
        <Field
          label="Catégories"
          name="tags"
          component={MultiSelectField}
          options={buildListAsInputOptions(tagsQuery.data || [], {
            labelKeyPath: 'name',
          })}
          disabled={disabled}
        />
      </Element>
    </FieldColumn>
  )
}

export default WorkPeriodTagsFilterField
